// ⭐ EDIT THIS — add your resort's real videos
// type: "youtube" → just paste the video ID from the YouTube URL
// type: "local"   → put the .mp4 file in public/videos/
export const videosData = [
  {
    id: 1,
    title: "Management & Staff Introduction",
    type: "local",
    src: "/videos/Resort.mp4",
    thumb: "/images/thumbnail/usha_resort.png",        // poster shown before play
  },
  {
    id: 2,
    title: "Wedding Highlights at USHA Resort",
    type: "youtube",
    youtubeId: "s8F5uBL02b8", 
    // thumb auto-generated from YouTube — no image needed
  },
  {
    id: 3,
    title: "Poolside — Evening View",
    type: "local",
    src: "/videos/poolside_function.mp4",
    thumb: "/images/Slider/11.png",
  },
    {
    id: 4,
    title: "Complete Resort Night View",
    type: "local",
    src: "/videos/Drone (4).MP4",
    thumb: "/images/thumbnail/Night_View.png",
  },
  {
    id: 5,
    title: "Drone Night Video Marriage Lawn",
    type: "local",
    src: "/videos/Drone (1).MP4",
    thumb: "/images/thumbnail/Drone_Night_Upper.png",
  },
];